import FaceGuideImage from "../../images/guide/face_guid.webp";
import React, {useContext, useState} from "react";
import Button from "../Button";
import ForeignerAuth from "../../pages/authentication/ForeignerAuth";
import ForeignerAuthenticationContext from "../../tools/contexts/authenticatonService/ForeignerAuthenticationContext";

const GuidSlides = [
    {
        image: FaceGuideImage,
        title: "احراز هویت ویدیویی ونیفای",
        subTitle: "برای تأیید هویت، لطفاً یک ویدیو از چهره خود ضبط کرده و ارسال کنید.",
        tipsTitle: 'لطفا هنگام ضبط ویدیو موارد زیر را رعایت کنید:',
        tips: ['عینک خود را بردارید.',
            'از ماسک استفاده نکنید.',
            'چهره‌تان باید کاملاً درون کادر قرار گیرد.',
            'در نور کافی ویدیو ضبط کنید.',
            'پشت به منبع نور قرار نگیرید.',
            'مدت زمان ضبط ویدیو 7 ثانیه می باشد.'
        ],
        texts: ``
    },

];
const ForeignerGuide = ({onClose}) => {
    const foreignerAuthenticationContext=useContext(ForeignerAuthenticationContext);

    const handleRedirect=()=>{
        const price=foreignerAuthenticationContext?.process?.payment?.info ? foreignerAuthenticationContext.process.payment.info.init_amount :0
        return foreignerAuthenticationContext.handleRedirectToDivar({price,status:"fail"})
    }
    return <div className="w-full  ">
        {GuidSlides.map((item, index) => {
            return <div className="flex min-h-screen items-center justify-start md:justify-center pt-4    flex-col">
                <h1 className="text-xl text-center font-bold mb-2">{item.title}</h1>
                <h1 className="text-center px-2 mb-4">{item.subTitle}</h1>
                <img className="w-11/12 mt-4 md:mt-20 md:w-5/12 lg:w-4/12 xl:w-3/12 " src={item.image} alt=""/>
                <div className="w-11/12 mx-auto   lg:w-4/12 xl:w-3/12 ">
                    {item?.tipsTitle &&
                        <p className="w-full border-t  pt-2 mx-auto text-green-500 font-bold  mt-8 ">{item.tipsTitle}</p>}
                    {item.tips && item.tips.length > 0 && <ol className="text-sm list-disc list-inside mt-1">{
                        item.tips.map((tip, index) => <li className="py-1  font-bold">{tip}</li>)
                    }</ol>
                    }
                    <div className="grid gap-3 fixed md:relative  bottom-0  md:bg-transparent md:p-0 bg-white py-2 px-2 left-0 right-0 mt-8 grid-cols-2">
                        <Button onClick={handleRedirect} rounded="rounded-xl" className="text-sm">بازگشت به دیوار</Button>
                        <Button onClick={onClose} rounded="rounded-xl" className="text-sm" theme="green" >ضبط ویدیو</Button>
                    </div>
                </div>
            </div>
        })}
    </div>
}
export default ForeignerGuide